import { HearthBeatLoader } from '@components/ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ButtonSC, getPropsForLoader } from './button.styled';

export type TPropsSC = {
  size?: 'SM' | 'LG' | 'MD' | 'NM';
  kind?: 'PRIMARY' | 'SECONDARY' | 'DANGER' | 'LINK';
  mt?: number;
  mb?: number;
  isBlock?: boolean;
  disabled?: boolean;
  shape?: 'round' | 'rectangular';
  loading?: boolean;
};

type TProps = {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean | void;
  text?: string;
  htmlType?: 'submit' | 'button';
  type?: 'submit' | 'button';
  style?: React.CSSProperties;
  onClick?(): void;
} & TPropsSC;

const Button: React.FC<TProps> = ({
  children,
  className,
  text,
  htmlType,
  onClick,
  disabled = false,
  shape = 'rectangular',
  loading,
  ...props
}) => {
  return (
    <ButtonSC
      {...props}
      shape={shape}
      className={className}
      type={htmlType}
      onClick={onClick}
      disabled={disabled}
      $loading={loading}
    >
      {loading ? (
        <div className="loader">
          <HearthBeatLoader loading {...(getPropsForLoader(props.kind, props.size) as any)} />
        </div>
      ) : null}
      <div className="button-content">{text ? <FormattedMessage id={text} /> : children}</div>
    </ButtonSC>
  );
};

Button.defaultProps = {
  htmlType: 'button',
  size: 'LG',
};

export default Button;
